import React, { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Modal,
  Paper,
} from "@mui/material";
import logo from "../../../assets/images/logos/light_logo_lg.png";
import { styled, ThemeProvider } from "@mui/system";
import theme from "../../../assets/theme";
import styles from "../../../assets/css/style.js";
import btnbg from "../../../assets/images/btnbg.png";
import { StyleSheet } from "react-native";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { TextInput } from "react-native-web";
import {
  Add,
  DeleteOutline,
  KeyboardBackspaceOutlined,
} from "@mui/icons-material";
import {
  document_type_devis,
  document_type_fiche_intervention,
} from "../../../config/keys.js";
import moment from "moment";
import PrestationService from "../../../store/apis/PrestationApi.js";
import ValidationButton from "../../../components/buttons/ValidationButton.js";
moment.locale("fr");

const PdfWrap = styled("div")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 390,
  fontSize: 14,
  lineHeight: "20px",
  color: "#fff",
  maxWidth: 725,
  border: "1px solid #03EBFF",
  backgroundColor: "rgba(0, 0, 0, .69)",
  padding: "20px 30px",

  ".paddingRight40": {
    paddingRight: 40,
  },
  ".infos": {
    maxWidth: "max-content",
    margin: "0 0 0 auto",
  },
  ".fz18": {
    fontSize: 18,
  },
  ".details": {
    margin: "30px 0 20px",

    ".dt1": {
      width: "56%",
    },
    ".dt2": {
      width: "44%",
    },
  },
  ".h2": {
    marginBottom: 10,
  },
  ".prodlist": {
    borderSpacing: 0,

    tr: {
      td: {
        padding: 6,

        "&:not(:nth-of-type(2))": {
          textAlign: "center",
        },
      },
      "&:first-of-type": {
        fontSize: 16,
        lineHeight: "23px",
      },
      "&:not(:first-of-type)": {
        border: "1px solid #03EBFF",
        td: {
          border: "1px solid #03EBFF",
          verticalAlign: "top",
        },
      },
    },
  },
  ".paiment": {
    margin: "0 -30px",
    padding: "10px 30px 30px",
    borderBottom: "1px solid #03EBFF",
  },
  ".signature": {
    padding: "10px 0",
    img: {
      display: "block",
      margin: "auto",
    },
  },
  ".textBfrBtns": {
    display: "flex",
    marginBottom: 20,
    "> div:first-of-type": {
      flex: 1,
    },
    "> div:last-child": {
      width: 250,
      textAlign: "center",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      margin: "0 -20px",
      width: "auto",

      "> div:last-child": {
        display: "none",
      },
    },
  },
  "._btssp": {
    marginTop: "40px",
    display: "flex",
    justifyContent: "space-between",

    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
      flexDirection: "column",
      gap: "20px",
    },

    "> div:first-of-type": {
      width: 250,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    "> div:last-child": {
      width: 250,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    "._blcsntr": {
      minHeight: "120px",
      marginTop: "10px",
      display: "flex",
      border: "2px dashed #04ebff",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 18,
      lineHeight: "22px",
      fontFamily: theme.typography.fontFamilyBauhaus,
      color: "#04ebff",

      "&.op15": {
        opacity: 0.15,
      },
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      margin: "10px -20px 0",
      width: "auto",

      ">div:last-child": {
        width: "100%",
      },
      "._blcsntr": {
        minHeight: 100,
        margin: "13px 0 0 0",
      },
    },
  },
  ".btn": {
    height: 44,
    fontSize: 18,
    width: "100%",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #03EBFF",

    "&.style1": {
      backgroundImage:
        "linear-gradient(360deg, rgba(62, 195, 236, 0.12) -36%, rgba(62, 195, 236, 0) 76%)",
      textTransform: "uppercase",
      borderWidth: 2,
      marginBottom: 10,
    },
  },
  ".txt": {
    fontSize: 12,
    lineHeight: "17px",
    margin: "20px 0",
  },
  ".ftr": {
    margin: "auto",
    maxWidth: 270,
    fontSize: 9,
    lineHeight: "13px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    ".fz18": {
      fontSize: 14,
    },
    ".head": {
      "> tbody > tr": {
        display: "flex",
        flexDirection: "column",

        img: {
          width: 105,
        },
      },
    },
    ".infos": {
      margin: 0,
      marginTop: "15px",

      td: {
        textAlign: "left",

        "&:last-child": {
          textAlign: "center",
        },
      },
    },
    ".paiment": {
      padding: "10px 10px 10px",

      "> table > tbody > tr": {
        display: "flex",
        flexDirection: "column-reverse",

        "> td": {
          marginBottom: 15,

          "&:last-child": {
            maxWidth: 170,
            width: "100%",
            margin: "0 0 0 auto",
          },
          "table td:first-of-type": {
            whiteSpace: "nowrap",
            verticalAlign: "text-bottom",
          },
          "table td": {
            paddingTop: 4,
          },
        },
      },
    },
    ".details": {
      marginBottom: 5,

      "> tbody > tr": {
        display: "flex",
        flexDirection: "column",

        "> td": {
          marginBottom: 15,
        },
      },
      ".dt1, .dt2": {
        width: "100%",

        td: {
          width: "50%",
        },
      },
    },
    ".prodlist ": {
      margin: "15px -31px 0",
      width: "calc(100% + 62px)",

      tr: {
        "&:first-of-type": {
          fontSize: 12,
        },
      },
      ".tgl": {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        "&:before": {
          content: "attr(data-label-sm)",
          fontSize: 14,
          fontWeight: "bold",
          fontFamily: theme.typography.fontFamilyBauhaus,
          color: "#000",
        },
        "&:after": {
          content: '""',
          border: "6px solid transparent",
          borderTopColor: theme.palette.primary.main,
          borderBottom: "none",
          marginLeft: 6,
        },
        "> div": {
          position: "absolute",
          top: "100%",
          left: 0,
          width: 200,
          backgroundColor: "#fff",
          padding: 4,
          zIndex: 100,
          border: "1px solid #ccc",
          borderRadius: 4,
          opacity: 0,
          visibility: "hidden",
        },
        "&:hover": {
          "> div": {
            opacity: 1,
            visibility: "visible",
          },
        },
      },
    },
    ".signature": {
      margin: "0 -20px",
      width: "auto",

      "> tbody > tr": {
        display: "flex",
        flexWrap: "wrap",

        td: {
          width: "50%",
          textAlign: "center",

          "&:first-of-type": {
            width: "100%",
            marginBottom: 15,
            textAlign: "left",
          },
        },
      },
    },
    ".txt": {
      margin: "20px -20px",
    },
  },
}));
const Table = styled("table")(({ theme }) => ({
  width: "100%",
  ".b": {
    fontWeight: "bold",
  },
  ".ffbauhaus": {
    fontFamily: theme.typography.fontFamilyBauhaus,
  },
}));
const Tbody = styled("tbody")(({ theme }) => ({}));
const Tr = styled("tr")(({ theme, color }) => ({
  color: color ? color : "inherit",
}));
const Td = styled("td")(({ theme }) => ({}));
const Img = styled("img")(({ theme }) => ({}));
const Link = styled("a")(({ theme }) => ({}));
const Strong = styled("strong")(({ theme }) => ({}));
const Card = styled("div")(({ theme, color, minheight, borderColor }) => ({
  color: color ? color : "inherit",
  "&.card": {
    border: "1px solid rgba(62, 195, 236, 0.6)",
    borderColor: borderColor ? borderColor : "rgba(62, 195, 236, 0.6)",
    padding: "10px 25px",
    minHeight: minheight ? minheight : 126,
  },
  [theme.breakpoints.down("sm")]: {
    "&.card": {
      padding: "10px 16px",
    },
  },
}));
const CRTBtn = styled("div")(({ theme }) => ({
  height: 60,
  position: "relative",
  textAlign: "center",
  fontFamily: theme.typography.fontFamilyBauhaus,
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: "18px",
  textAlign: "center",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "5px",
  background:
    "radial-gradient(circle at center, rgba(3, 235, 255, .31) 0%, transparent 88%, transparent 0%)",

  ".before": {
    width: 15,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    bottom: 0,
    right: 0,
    transformOrigin: "center",
    transform: "translate(2px, -5px) rotate(-45deg)",
  },
  ".after": {
    width: 15,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    left: 0,
    top: 0,
    transformOrigin: "center",
    transform: "translate(-2px, 5px) rotate(-45deg)",
  },
  "&:after": {
    content: "''",
    position: "absolute",
    right: 0,
    top: 0,
    width: "calc(100% - 10px)",
    height: "calc(100% - 10px)",
    borderTop: "1px solid " + theme.palette.primary.main,
    borderRight: "1px solid " + theme.palette.primary.main,
  },
  "&:before": {
    content: "''",
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "calc(100% - 10px)",
    height: "calc(100% - 10px)",
    borderBottom: "1px solid " + theme.palette.primary.main,
    borderLeft: "1px solid " + theme.palette.primary.main,
  },
}));

const Buttons = styled("div")(({ theme }) => ({
  textAlign: "right",
  maxWidth: 725,
  marginTop: 20,

  a: {
    height: 43,
    lineHeight: "43px",
    backgroundImage: "url(" + btnbg + ")",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    fontSize: 16,
    textAlign: "center",
    padding: "0 25px",
    display: "inline-block",
    fontFamily: theme.typography.fontFamilyBauhaus,
    marginLeft: 15,

    img: {
      marginRight: 15,
      verticalAlign: "middle",
    },
  },
}));

export default function PDFFile({ presta, goBack, onSave }) {
  const [loading, setLoading] = useState(false);
  const [detailDevis, setDetailDevis] = useState(
    presta?.documents?.find(
      (obj) => obj.type.toLowerCase() === document_type_devis
    )
      ? presta?.documents?.find(
          (obj) => obj.type.toLowerCase() === document_type_devis
        )
      : null
  );
  const [detailDocument, setDetailDocument] = useState(
    presta?.documents?.find(
      (obj) => obj.type.toLowerCase() === document_type_fiche_intervention
    )
      ? presta?.documents?.find(
          (obj) => obj.type.toLowerCase() === document_type_fiche_intervention
        )
      : null
  );

  const [subServices, setSubServices] = useState(
    presta?.service?.length > 0 ? presta?.service : []
  );
  const [date, setDate] = useState(moment());
  const [duree, setDuree] = useState(presta?.duree_intervention);
  const [heureDebut, setHeureDebut] = useState(presta?.debut_intervention);
  const [heureFin, setHeureFin] = useState(presta?.fin_intervention);
  const [signed, setSigned] = useState(
    detailDocument?.signature_prestataire ? true : false
  );

  const [signatureData, setSignatureData] = useState(
    detailDocument?.signature_prestataire
  );

  // When component mounts, if there's a signature in the database, ensure it's properly displayed
  useEffect(() => {
    if (detailDocument?.signature_prestataire) {
      try {
        // Log the first part of the signature data for debugging
        console.log(
          "Signature from DB (first 50 chars):",
          typeof detailDocument.signature_prestataire === "string"
            ? detailDocument.signature_prestataire.substring(0, 50) + "..."
            : "Not a string"
        );

        // Check if the signature data is valid
        if (typeof detailDocument.signature_prestataire === "string") {
          // If it doesn't start with 'data:', add the prefix
          if (!detailDocument.signature_prestataire.startsWith("data:")) {
            setSignatureData(
              `data:image/png;base64,${detailDocument.signature_prestataire}`
            );
          } else {
            setSignatureData(detailDocument.signature_prestataire);
          }
          setSigned(true);
        } else {
          console.error(
            "Signature data is not a string:",
            detailDocument.signature_prestataire
          );
        }
      } catch (error) {
        console.error("Error processing signature:", error);
      }
    }
  }, [detailDocument]);
  const [modalOpen, setModalOpen] = useState(false);
  const sigCanvas = useRef({});

  const [errorDuree, setErrorDuree] = useState(false);
  const [errorDebut, setErrorDebut] = useState(false);
  const [errorFin, setErrorFin] = useState(false);
  const [error, setError] = useState(false);

  const [imageAfters, setImageAfters] = useState(presta?.image_afters);
  const [imageBefores, setImageBefores] = useState(presta?.image_befores);

  const [selectedFilesBefore, setSelectedFilesBefore] = useState([]);
  const [selectedFilesAfter, setSelectedFilesAfter] = useState([]);

  const handleFileChangeBefore = (event) => {
    setSelectedFilesBefore(event.target.files);
  };
  const handleFileChangeAfter = (event) => {
    setSelectedFilesAfter(event.target.files);
  };

  const handleDeleteFileBefore = (index) => {
    const newUploadedFiles = Array.from(selectedFilesBefore).filter(
      (_, i) => i !== index
    );
    setSelectedFilesBefore(newUploadedFiles);
  };

  const handleDeleteFileAfter = (index) => {
    const newUploadedFiles = Array.from(selectedFilesAfter).filter(
      (_, i) => i !== index
    );
    setSelectedFilesAfter(newUploadedFiles);
  };

  const handleFileUploadBefore = async () => {
    setError(false);
    const formDataBefore = new FormData();
    formDataBefore.append("demande", presta?.id);
    for (let i = 0; i < selectedFilesBefore.length; i++) {
      formDataBefore.append("files[]", selectedFilesBefore[i]);
    }

    try {
      if (selectedFilesBefore.length > 0) {
        PrestationService.addImagesBefore(formDataBefore).then((response) => {
          if (response.code === "ERR_NETWORK") {
            setError(true);
            setLoading(false);
          } else {
            handleFileUploadAfter();
          }
          console.log(response);
        });
      } else {
        handleFileUploadAfter();
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      setError(true);
      setLoading(false);
    }
  };

  const handleFileUploadAfter = async () => {
    setError(false);
    const formDataAfter = new FormData();
    formDataAfter.append("demande", presta?.id);
    for (let i = 0; i < selectedFilesAfter.length; i++) {
      formDataAfter.append("files[]", selectedFilesAfter[i]);
    }
    try {
      if (selectedFilesAfter.length > 0) {
        PrestationService.addImagesAfter(formDataAfter).then((response) => {
          if (response.code === "ERR_NETWORK") {
            setError(true);
            setLoading(false);
          } else {
            handleValidatePrestation();
          }
          console.log(response);
        });
      } else {
        handleValidatePrestation();
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      setError(true);
      setLoading(false);
    }
  };

  const handleValidatePrestation = () => {
    /* setLoading(false);
    return; */
    let data = {
      date_prestation: date,
      duree_intervention: duree,
      debut_intervention: heureDebut,
      fin_intervention: heureFin,
    };

    PrestationService.editPrestation(presta?.id, data).then((response) => {
      let data = {
        dateSignaturePrestataire: new Date(),
        signaturePrestataire: signatureData,
      };

      PrestationService.editDocument(detailDocument?.id, data).then(
        (response) => {
          setLoading(false);
          onSave(presta);
        }
      );
    });
  };

  const validateDocument = async () => {
    /* onSave(presta);
    return; */

    if (!signed || !signatureData) {
      alert("Veuillez signer le document avant de valider");
      return;
    }
    if (!duree) {
      setErrorDuree(true);
    } else {
      setErrorDuree(false);
    }
    if (!heureDebut) {
      setErrorDebut(true);
    } else {
      setErrorDebut(false);
    }
    if (!heureFin) {
      setErrorFin(true);
    } else {
      setErrorFin(false);
    }
    if (!duree || !heureDebut || !heureFin) return;

    setLoading(true);

    handleFileUploadBefore();
    //const resultAfter = await handleFileUploadAfter();
    /*  console.log(resultBefore, resultAfter, error);
    if (!error) {
      console.log("kjgkjhgkjhgfkjhfgkghf");
      
    } */
    //
    /* let dataSubServices = [];
    subServices.map((subService, index) => {
      dataSubServices.push({
        prestation: "/api/demandes/" + presta?.id,
        service: "/api/services/" + subService.service.value,
        quantity: subService.quantity,
        prix: subService.prix,
      });
      PrestationService.addServices({
        prestation: "/api/demandes/" + presta?.id,
        service: "/api/services/" + subService.service.value,
        quantity: subService.quantity,
        prix: subService.prix,
      }).then((response) => {
        //setLoading(false);
        console.log(response);
      });
    });

    let dataDocument = {
      prestation: "/api/demandes/" + presta?.id,
      type: document_type_devis,
    };

    let data = {
      etape: "2",
      total_ht: total.toString(),
      total_ttc: (total + total * 0.2).toString(),
    };
    PrestationService.addDocument(dataDocument).then((response) => {
      //setLoading(false);
      console.log(response);
    });

    */
  };

  return (
    <ThemeProvider theme={theme}>
      <Box 
        display={"flex"} 
        alignItems="flex-start"
        justifyContent="center"
        width="100%"
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "auto" },
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <Box
            display={"flex"}
            justifyContent="space-between"
            marginBottom={"6px"}
          >
            <Box>
              <Button
                startIcon={<KeyboardBackspaceOutlined />}
                variant={"text"}
                color={"primary"}
                sx={{ fontWeight: 700, textTransform: "capitalize" }}
                onClick={goBack}
              >
                Retour
              </Button>
            </Box>
            {/* <Box
              fontSize="16px"
              fontFamily={theme.typography.fontFamilyBauhaus}
            >
              <BorderColorIcon fontSize="16" /> Modifier
            </Box> */}
          </Box>
          <PdfWrap 
            className="pdf" 
            style={StyleSheet.flatten(styles.pdf)}
            sx={{
              width: { xs: "100%", md: "auto" },
              maxWidth: "100%",
              margin: "0 auto",
              overflowX: { xs: "auto", md: "visible" },
            }}
          >
            <Table className="head">
              <Tbody>
                <Tr>
                  <Td>
                    <Img src={logo} />
                  </Td>
                  <Td>
                    <Table className="infos">
                      <Tbody>
                        <Tr className="b fz18">
                          <Td align="right" className="paddingRight40">
                            Fiche d’intervention N°
                          </Td>
                          <Td>
                            {detailDocument
                              ? detailDocument.id
                              : moment().format("DDMMYYYYHHmmss")}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Td>
                </Tr>
              </Tbody>
            </Table>

            <Table className="details">
              <Tbody>
                <Tr>
                  <Td className="dt1">
                    <Table>
                      <Tbody>
                        <Tr>
                          <Td>
                            <Strong className="fz18">
                              Référence{" "}
                              {presta?.reference
                                ? presta?.reference
                                : presta?.id}
                            </Strong>
                          </Td>
                        </Tr>
                        {detailDevis && (
                          <Tr>
                            <Td>
                              <Strong className="fz18">
                                Devis N° {detailDevis.id}
                              </Strong>
                            </Td>
                          </Tr>
                        )}
                        <Tr>
                          <Td>
                            <Strong>Adresse du lieu concerné</Strong>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>{presta?.client?.adresse}</Td>
                        </Tr>
                        <Tr>
                          <Td>{presta?.client?.code_postal}</Td>
                        </Tr>
                        <Tr>
                          <Td>{presta?.client?.ville}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Td>
                  <Td className="dt2">
                    <Table>
                      <Tbody>
                        <Tr>
                          <Td align="right" width="50%">
                            <Strong>Date</Strong>
                          </Td>
                          <Td>
                            <Strong>
                              <TextInput
                                type="text"
                                style={{
                                  height: 25,
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  border: "1px solid #fff",
                                  textAlign: "center",
                                  color: "#fff",
                                  placeholderTextColor:
                                    theme.palette.secondary.main,
                                }}
                                value={date.format("DD/MM/YYYY")}
                                placeholder="--"
                                disabled
                              />
                            </Strong>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td align="right">
                            <Strong>Durée</Strong>
                          </Td>
                          <Td>
                            <TextInput
                              type="number"
                              keyboardType="numeric"
                              style={{
                                height: 25,
                                paddingLeft: 10,
                                paddingRight: 10,
                                border:
                                  "1px solid " + theme.palette.secondary.main,
                                textAlign: "center",
                                color: "#000",
                                background: "#fff",
                                borderColor: errorDuree
                                  ? "red"
                                  : theme.palette.secondary.main,
                                placeholderTextColor:
                                  theme.palette.secondary.main,
                              }}
                              onChange={(e) => {
                                setDuree(e.target.value);
                              }}
                              value={duree}
                            />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td align="right">
                            <Strong>Début</Strong>
                          </Td>
                          <Td>
                            <input
                              type="time"
                              name="time-debut"
                              id="time-debut"
                              lang="fr_FR"
                              locale="fr_FR"
                              style={{
                                height: 25,
                                paddingLeft: 10,
                                paddingRight: 10,
                                border:
                                  "1px solid " + theme.palette.secondary.main,
                                textAlign: "center",
                                color: "#000",
                                width: "100%",
                                borderColor: errorDebut
                                  ? "red"
                                  : theme.palette.secondary.main,
                                placeholderTextColor:
                                  theme.palette.secondary.main,
                              }}
                              onChange={(e) => {
                                setHeureDebut(e.target.value);
                              }}
                              value={heureDebut}
                            />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td align="right">
                            <Strong>Fin</Strong>
                          </Td>
                          <Td>
                            <input
                              type="time"
                              name="time-fin"
                              id="time-fin"
                              lang="fr_FR"
                              locale="fr_FR"
                              style={{
                                height: 25,
                                paddingLeft: 10,
                                paddingRight: 10,
                                border:
                                  "1px solid " + theme.palette.secondary.main,
                                textAlign: "center",
                                color: "#000",
                                width: "100%",
                                borderColor: errorFin
                                  ? "red"
                                  : theme.palette.secondary.main,
                                placeholderTextColor:
                                  theme.palette.secondary.main,
                              }}
                              onChange={(e) => {
                                setHeureFin(e.target.value);
                              }}
                              value={heureFin}
                            />
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Td>
                </Tr>
              </Tbody>
            </Table>

            <Box
              display={"flex"}
              flexWrap={"wrap"}
              justifyContent="space-between"
            >
              <Box width={"calc(50% - 5px)"}>
                <Typography variant="h2" className="h2">
                  Client
                </Typography>
                <Card className="card" minheight="42px">
                  {`${presta?.client?.prenom} ${presta?.client?.nom}`}
                </Card>
              </Box>
              <Box width={"calc(50% - 5px)"}>
                <Typography variant="h2" className="h2">
                  Intervenant(s)
                </Typography>
                <Card className="card" minheight="42px">
                  {`${presta?.prestataire?.prenom} ${presta?.prestataire?.nom}`}
                </Card>
              </Box>
            </Box>
            <Typography variant="h2" className="h2" marginTop={"30px"}>
              Nature du problème
            </Typography>
            <Card className="card" minheight="auto">
              {presta?.client?.problemes.map((x) => `${x}`)}
            </Card>
            <Typography variant="h2" className="h2" marginTop={"30px"}>
              Détail
            </Typography>
            <Card className="card" minheight="auto">
              {presta?.detail}
            </Card>

            <Table className="prodlist">
              <Tbody>
                <Tr>
                  <Td width="90">Réf</Td>
                  <Td>Désignation</Td>
                  <Td width="70">Qté</Td>
                </Tr>
                {subServices.map((subService, index) => {
                  return (
                    <Tr color={theme.palette.secondary.main}>
                      <Td className="td b fz18 ffbauhaus">
                        {subService?.service && subService?.service?.id !== 0
                          ? "#" + subService?.service?.id
                          : "--"}
                      </Td>
                      <Td>
                        <Box className="tgl" data-label-sm="DIAGNOSTIC">
                          <Box>
                            {subService?.service &&
                            subService?.service?.id !== 0
                              ? subService?.service?.libelle
                              : subService?.nom_service}
                            <br />
                            {subService?.service &&
                            subService?.service?.id !== 0
                              ? subService?.service?.description
                              : ""}
                          </Box>
                        </Box>
                      </Td>
                      <Td>
                        <Strong>{subService?.quantity}</Strong>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>

            <Box
              display={"flex"}
              flexDirection={{ xs: "column", sm: "row" }}
              marginTop={{ xs: "30px", sm: "50px" }}
              gap={{ xs: 3, sm: 2 }}
            >
              {/* Section Photos Avant */}
              <Box
                flex="1"
                display={"flex"}
                flexDirection="column"
                width={{ xs: "100%", sm: "50%" }}
              >
                {/* Titre et bouton d'ajout */}
                <Box
                  fontFamily={theme.typography.fontFamilyBauhaus}
                  display={"flex"}
                  alignItems="start"
                  justifyContent={"center"}
                  cursor={"pointer"}
                  width={{ xs: "100%", sm: "auto" }}
                  mb={2}
                >
                  <Box 
                    color={"#F2E208"} 
                    width={"100%"} 
                    textAlign={"center"}
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                    }}
                  >
                    {detailDocument && detailDocument.status !== "signed" ? (
                      <label
                        htmlFor="file-input-after"
                        className="custom-file-upload"
                      >
                        Ajouter des photos
                        <br />
                        avant la réalisation
                      </label>
                    ) : (
                      <label
                        htmlFor="file-input-after"
                        className="custom-file-upload"
                      >
                        Photos avant la réalisation
                      </label>
                    )}
                  </Box>
                  {detailDocument && detailDocument.status !== "signed" && (
                    <Box 
                      fontFamily={theme.typography.fontFamily} 
                      flex="1"
                      display="flex"
                      justifyContent={{ xs: "flex-start", sm: "center" }}
                      ml={{ xs: 2, sm: 0 }}
                    >
                      <Box
                        color={"#F2E208"}
                        sx={{
                          border: "1px solid #F2E208",
                          padding: { xs: "4px 8px", sm: "8px 15px" },
                          width: { xs: "50px", sm: "68px" },
                          height: { xs: "40px", sm: "51px" },
                          borderRadius: "5px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        htmlFor="file-input-after"
                      >
                        <input
                          id="file-input-after"
                          type="file"
                          multiple
                          accept="image/*"
                          onChange={handleFileChangeBefore}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor="file-input-after"
                          className="custom-file-upload"
                          style={{ display: "flex", margin: 0 }}
                        >
                          <Add
                            fontSize={window.innerWidth <= 600 ? "medium" : "large"}
                            sx={{
                              cursor: "pointer",
                            }}
                          />
                        </label>
                      </Box>
                    </Box>
                  )}
                </Box>
                
                {/* Prévisualisation des photos avant */}
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  width={{ xs: "100%", sm: "auto" }}
                  mt={1}
                >
                  <div 
                    className="image-preview-container"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    {imageBefores &&
                      imageBefores.map((file, key) => {
                        return (
                          <div 
                            key={key} 
                            className="image-preview"
                            style={{
                              margin: "5px",
                            }}
                          >
                            <p style={{ margin: 0 }}>
                              <a href={file.file} target="_blank">
                                <img
                                  src={file.file}
                                  alt={file.file}
                                  width={window.innerWidth <= 600 ? "70px" : "80px"}
                                  style={{
                                    verticalAlign: "middle",
                                    border: "1px solid #F2E208",
                                    borderRadius: "4px",
                                  }}
                                />
                              </a>
                              <br />
                              {detailDocument && detailDocument.status !== "signed" && (
                                <Button
                                  startIcon={<DeleteOutline />}
                                  variant={"text"}
                                  sx={{
                                    fontWeight: { xs: 700 },
                                    fontSize: { xs: 12, sm: 16 },
                                    fontFamily: { xs: "Bauhaus" },
                                    textTransform: "capitalize",
                                    padding: { xs: "2px 5px", sm: "6px 8px" },
                                    minWidth: { xs: "auto", sm: "64px" },
                                  }}
                                  color="inherit"
                                  onClick={() => handleDeleteOldFileBefore(key, file.id)}
                                >
                                  {window.innerWidth <= 600 ? "" : "Supprimer"}
                                </Button>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    {selectedFilesBefore &&
                      Array.from(selectedFilesBefore).map((file, key) => {
                        return (
                          <div 
                            key={key} 
                            className="image-preview"
                            style={{
                              margin: "5px",
                            }}
                          >
                            <p style={{ margin: 0 }}>
                              <a href={URL.createObjectURL(file)} target="_blank">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={file.name}
                                  width={window.innerWidth <= 600 ? "70px" : "80px"}
                                  style={{
                                    verticalAlign: "middle",
                                    border: "1px solid #F2E208",
                                    borderRadius: "4px",
                                  }}
                                />
                              </a>
                              <br />
                              {detailDocument && detailDocument.status !== "signed" && (
                                <Button
                                  startIcon={<DeleteOutline />}
                                  variant={"text"}
                                  sx={{
                                    fontWeight: { xs: 700 },
                                    fontSize: { xs: 12, sm: 16 },
                                    fontFamily: { xs: "Bauhaus" },
                                    textTransform: "capitalize",
                                    padding: { xs: "2px 5px", sm: "6px 8px" },
                                    minWidth: { xs: "auto", sm: "64px" },
                                  }}
                                  color="inherit"
                                  onClick={() => handleDeleteFileBefore(key)}
                                >
                                  {window.innerWidth <= 600 ? "" : "Supprimer"}
                                </Button>
                              )}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                </Box>
              </Box>
              
              {/* Section Photos Après */}
              <Box
                flex="1"
                display={"flex"}
                flexDirection="column"
                width={{ xs: "100%", sm: "50%" }}
              >
                {/* Titre et bouton d'ajout */}
                <Box
                  fontFamily={theme.typography.fontFamilyBauhaus}
                  display={"flex"}
                  alignItems="start"
                  justifyContent={"center"}
                  cursor={"pointer"}
                  width={{ xs: "100%", sm: "auto" }}
                  mb={2}
                >
                  <Box 
                    color={"#F2E208"} 
                    width={"100%"} 
                    textAlign={"center"}
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                    }}
                  >
                    {detailDocument && detailDocument.status !== "signed" ? (
                      <label
                        htmlFor="file-input-befor"
                        className="custom-file-upload"
                      >
                        Ajouter des photos
                        <br />
                        après la réalisation
                      </label>
                    ) : (
                      <label
                        htmlFor="file-input-befor"
                        className="custom-file-upload"
                      >
                        Photos après la réalisation
                      </label>
                    )}
                  </Box>
                  {detailDocument && detailDocument.status !== "signed" && (
                    <Box 
                      fontFamily={theme.typography.fontFamily} 
                      flex="1"
                      display="flex"
                      justifyContent={{ xs: "flex-start", sm: "center" }}
                      ml={{ xs: 2, sm: 0 }}
                    >
                      <Box
                        color={"#F2E208"}
                        sx={{
                          border: "1px solid #F2E208",
                          padding: { xs: "4px 8px", sm: "8px 15px" },
                          width: { xs: "50px", sm: "68px" },
                          height: { xs: "40px", sm: "51px" },
                          borderRadius: "5px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        htmlFor="file-input-befor"
                      >
                        <input
                          id="file-input-befor"
                          type="file"
                          multiple
                          accept="image/*"
                          onChange={handleFileChangeAfter}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor="file-input-befor"
                          className="custom-file-upload"
                          style={{ display: "flex", margin: 0 }}
                        >
                          <Add
                            fontSize={window.innerWidth <= 600 ? "medium" : "large"}
                            sx={{
                              cursor: "pointer",
                            }}
                          />
                        </label>
                      </Box>
                    </Box>
                  )}
                </Box>
                
                {/* Prévisualisation des photos après */}
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  width={{ xs: "100%", sm: "auto" }}
                  mt={1}
                >
                  <div 
                    className="image-preview-container"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    {imageAfters &&
                      imageAfters.map((file, key) => {
                        return (
                          <div 
                            key={key} 
                            className="image-preview"
                            style={{
                              margin: "5px",
                            }}
                          >
                            <p style={{ margin: 0 }}>
                              <a href={file.file} target="_blank">
                                <img
                                  src={file.file}
                                  alt={file.file}
                                  width={window.innerWidth <= 600 ? "70px" : "80px"}
                                  style={{
                                    verticalAlign: "middle",
                                    border: "1px solid #F2E208",
                                    borderRadius: "4px",
                                  }}
                                />
                              </a>
                              <br />
                              {detailDocument && detailDocument.status !== "signed" && (
                                <Button
                                  startIcon={<DeleteOutline />}
                                  variant={"text"}
                                  sx={{
                                    fontWeight: { xs: 700 },
                                    fontSize: { xs: 12, sm: 16 },
                                    fontFamily: { xs: "Bauhaus" },
                                    textTransform: "capitalize",
                                    padding: { xs: "2px 5px", sm: "6px 8px" },
                                    minWidth: { xs: "auto", sm: "64px" },
                                  }}
                                  color="inherit"
                                  onClick={() => handleDeleteOldFileAfter(key, file.id)}
                                >
                                  {window.innerWidth <= 600 ? "" : "Supprimer"}
                                </Button>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    {selectedFilesAfter &&
                      Array.from(selectedFilesAfter).map((file, key) => {
                        return (
                          <div 
                            key={key} 
                            className="image-preview"
                            style={{
                              margin: "5px",
                            }}
                          >
                            <p style={{ margin: 0 }}>
                              <a href={URL.createObjectURL(file)} target="_blank">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={file.name}
                                  width={window.innerWidth <= 600 ? "70px" : "80px"}
                                  style={{
                                    verticalAlign: "middle",
                                    border: "1px solid #F2E208",
                                    borderRadius: "4px",
                                  }}
                                />
                              </a>
                              <br />
                              <Button
                                startIcon={<DeleteOutline />}
                                variant={"text"}
                                sx={{
                                  fontWeight: { xs: 700 },
                                  fontSize: { xs: 12, sm: 16 },
                                  fontFamily: { xs: "Bauhaus" },
                                  textTransform: "capitalize",
                                  padding: { xs: "2px 5px", sm: "6px 8px" },
                                  minWidth: { xs: "auto", sm: "64px" },
                                }}
                                color="inherit"
                                onClick={() => handleDeleteFileAfter(key)}
                              >
                                {window.innerWidth <= 600 ? "" : "Supprimer"}
                              </Button>
                            </p>
                          </div>
                        );
                      })}
                  </div>
                </Box>
              </Box>
            </Box>
            {error && (
              <Typography
                fontSize={{
                  xs: 18,
                  textAlign: "center",
                }}
                color="red"
              >
                Il y a eu une erreur lors du téléchargement des images.
              </Typography>
            )}

            <Box
              fontFamily={theme.typography.fontFamilyBauhaus}
              display={"flex"}
              flexDirection={{ xs: "column", sm: "row" }}
              marginTop={{ xs: "30px", sm: "50px" }}
              gap={{ xs: 2, sm: 0 }}
            >
              <Box
                flex="1"
                display={"flex"}
                alignItems="center"
                marginRight={{ xs: 0, sm: "15px" }}
                width={{ xs: "100%", sm: "auto" }}
              >
                <Box 
                  marginRight={"10px"}
                  minWidth={{ xs: "50px", sm: "auto" }}
                  fontSize={{ xs: "14px", sm: "16px" }}
                >
                  Fait à
                </Box>
                <Box fontFamily={theme.typography.fontFamily} flex="1">
                  <Card 
                    minheight="auto" 
                    className="card"
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      padding: { xs: "8px", sm: "10px" },
                    }}
                  >
                    {presta?.client?.adresse} {presta?.client?.code_postal},{" "}
                    {presta?.client?.ville}
                  </Card>
                </Box>
              </Box>
              <Box
                maxWidth={{ xs: "100%", sm: "225px" }}
                flex="1"
                display={"flex"}
                alignItems="center"
              >
                <Box 
                  marginRight={"10px"}
                  minWidth={{ xs: "50px", sm: "auto" }}
                  fontSize={{ xs: "14px", sm: "16px" }}
                >
                  Le
                </Box>
                <Box fontFamily={theme.typography.fontFamily} flex="1">
                  <Card 
                    minheight="auto" 
                    className="card"
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      padding: { xs: "8px", sm: "10px" },
                    }}
                  >
                    {detailDocument
                      ? moment
                          .parseZone(detailDocument.date)
                          .format("DD/MM/YYYY")
                      : moment().format("DD/MM/YYYY")}
                  </Card>
                </Box>
              </Box>
            </Box>

            <Box 
              className="_btssp"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 0 },
              }}
            >
              {/* <Box 
                margin={{ xs: 0, sm: 1 }}
                width={{ xs: "100%", sm: "auto" }}
                flex="1"
              >
                <Box 
                  fontSize={{ xs: "14px", sm: "16px" }}
                  textAlign={{ xs: "center", sm: "left" }}
                  mb={1}
                >
                  Signature du client
                </Box>
                <Box 
                  className="_blcsntr op15"
                  sx={{
                    height: { xs: 120, sm: "auto" },
                    minHeight: { xs: 120, sm: 150 },
                  }}
                ></Box>
              </Box> */}
              <Box 
                margin={{ xs: 0, sm: 1 }}
                width={{ xs: "100%", sm: "auto" }}
                flex="1"
              >
                <Box 
                  fontSize={{ xs: "14px", sm: "16px" }}
                  textAlign={{ xs: "center", sm: "left" }}
                  mb={1}
                >
                  Signature de l'intervenant
                </Box>
                <Box
                  className="_blcsntr"
                  onClick={() => setModalOpen(true)}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: { xs: 120, sm: "auto" },
                    minHeight: { xs: 120, sm: 150 },
                  }}
                >
                  {signed && signatureData ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={signatureData}
                        alt="Signature"
                        style={{
                          maxWidth: "90%",
                          maxHeight: "90%",
                          objectFit: "contain",
                        }}
                        crossOrigin="anonymous"
                        onError={(e) => {
                          console.error("Image failed to load");
                          //e.target.style.display = 'none';
                          //e.target.parentNode.innerHTML = '<div style="color: #03EBFF; text-align: center;">Signature enregistrée ✓</div>';
                        }}
                      />
                    </div>
                  ) : (
                    <Typography
                      sx={{
                        color: "#03EBFF",
                        fontSize: { xs: "13px", sm: "16px" },
                        textAlign: "center",
                      }}
                    >
                      Cliquer ici pour signer
                    </Typography>
                  )}
                </Box>

                {/* Signature Modal */}
                <Modal
                  open={modalOpen}
                  onClose={() => {
                    if (!signatureData) {
                      setSigned(false);
                    }
                    setModalOpen(false);
                  }}
                  aria-labelledby="signature-modal-title"
                  aria-describedby="signature-modal-description"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Paper
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, .85)",
                      border: "1px solid #03EBFF",
                      boxShadow: 24,
                      p: { xs: 2, sm: 4 },
                      maxWidth: 500,
                      width: { xs: "95%", sm: "90%" },
                      maxHeight: { xs: "90vh", sm: "auto" },
                      overflowY: "auto",
                    }}
                  >
                    <Typography
                      id="signature-modal-title"
                      variant="h6"
                      component="h2"
                      sx={{
                        color: "#fff",
                        fontFamily: theme.typography.fontFamilyBauhaus,
                        mb: 2,
                        textAlign: "center",
                        fontSize: { xs: "18px", sm: "1.25rem" },
                      }}
                    >
                      Signature de l'intervenant
                    </Typography>

                    <Box
                      sx={{
                        backgroundColor: "rgba(0, 0, 0, .5)",
                        border: "2px dashed #03EBFF",
                        height: { xs: 180, sm: 200 },
                        mb: 2,
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "4px",
                      }}
                    >
                      <SignatureCanvas
                        ref={sigCanvas}
                        canvasProps={{
                          width: 450,
                          height: 200,
                          style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          },
                          className: "signature-canvas",
                        }}
                        backgroundColor="rgba(0,0,0,0)"
                        penColor="#fff"
                        onEnd={() => {
                          try {
                            // Get signature as PNG data URL with transparent background
                            // Use a lower quality/resolution to reduce data size and avoid CORS issues
                            const signatureImage = sigCanvas.current.toDataURL(
                              "image/png",
                              0.5
                            );
                            console.log(
                              "New signature created:",
                              signatureImage.substring(0, 50) + "..."
                            );
                            setSignatureData(signatureImage);
                          } catch (error) {
                            console.error("Error creating signature:", error);
                          }
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex", 
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        gap: { xs: 2, sm: 0 },
                      }}
                    >
                      <Button
                        onClick={() => {
                          sigCanvas.current.clear();
                          setSignatureData(null);
                        }}
                        sx={{
                          color: "#03EBFF",
                          fontFamily: theme.typography.fontFamilyBauhaus,
                          fontSize: { xs: "14px", sm: "14px" },
                          order: { xs: 2, sm: 1 },
                        }}
                      >
                        Effacer
                      </Button>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "row", sm: "row" },
                          justifyContent: { xs: "space-between", sm: "flex-end" },
                          width: { xs: "100%", sm: "auto" },
                          order: { xs: 1, sm: 2 },
                        }}
                      >
                        <Button
                          onClick={() => {
                            setModalOpen(false);
                            setSigned(false);
                            sigCanvas.current.clear();
                            setSignatureData(null);
                          }}
                          sx={{
                            color: "#fff",
                            fontFamily: theme.typography.fontFamilyBauhaus,
                            mr: 1,
                            fontSize: { xs: "14px", sm: "14px" },
                            flex: { xs: 1, sm: "none" },
                          }}
                        >
                          Annuler
                        </Button>

                        <Button
                          onClick={() => {
                            if (signatureData) {
                              setSigned(true);
                              setModalOpen(false);
                            }
                          }}
                          disabled={!signatureData}
                          sx={{
                            color: signatureData
                              ? "#03EBFF"
                              : "rgba(3, 235, 255, 0.5)",
                            fontFamily: theme.typography.fontFamilyBauhaus,
                            border: "1px solid",
                            borderColor: signatureData
                              ? "#03EBFF"
                              : "rgba(3, 235, 255, 0.5)",
                            fontSize: { xs: "14px", sm: "14px" },
                            flex: { xs: 1, sm: "none" },
                          }}
                        >
                          Valider
                        </Button>
                      </Box>
                    </Box>
                  </Paper>
                </Modal>
              </Box>
            </Box>
          </PdfWrap>

          {loading ? (
            <CircularProgress />
          ) : (
            detailDocument &&
            detailDocument.status !== "signed" && (
              <Buttons>
                <ValidationButton icon handleClick={goBack}>
                  Annuler
                </ValidationButton>
                <ValidationButton
                  handleClick={validateDocument}
                  disabled={signed ? false : true}
                >
                  Valider
                </ValidationButton>
              </Buttons>
            )
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
